import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Col, Row } from "react-bootstrap";
import UploadIMG from "../components/uploads/UploadIMG";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { createAndUpdateCarpark, getDataCarpark } from "../api/ourservice_api";
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function Carpark() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [txtEnDescValue, setTxtEnDescValue] = useState('');
    const [txtThDescValue, setTxtThDescValue] = useState('');
    const [txtEnHelpDescValue, setTxtEnHelpDescValue] = useState('');
    const [txtThHelpDescValue, setTxtThHelpDescValue] = useState('');
    const [txtEnBuildingDescValue, setTxtEnBuildingDescValue] = useState('');
    const [txtThBuildingDescValue, setTxtThBuildingDescValue] = useState('');
    const [txtEnMailroomDescValue, setTxtEnMailroomDescValue] = useState('');
    const [txtThMailroomDescValue, setTxtThMailroomDescValue] = useState('');
    const [txtEnShuttleDescValue, setTxtEnShuttleDescValue] = useState('');
    const [txtThShuttleDescValue, setTxtThShuttleDescValue] = useState('');
    const [txtEnDriverDescValue, setTxtEnDriverDescValue] = useState('');
    const [txtThDriverDescValue, setTxtThDriverDescValue] = useState('');
    const [txtEnfacialDescValue, setTxtEnfacialDescValue] = useState('');
    const [txtThfacialDescValue, setTxtThfacialDescValue] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);
    const [images5, setImages5] = useState([]);
    const [imagesFromApi5, setImagesFromApi5] = useState([]);
    const [images6, setImages6] = useState([]);
    const [imagesFromApi6, setImagesFromApi6] = useState([]);

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };
    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };
    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };
    const handleSelectedImages4 = (images) => {
        setImages4(images);
    };
    const handleSelectedRemoveImg4 = (data) => {
        setImages4(data);
    };
    const handleSelectedImages5 = (images) => {
        setImages5(images);
    };
    const handleSelectedRemoveImg5 = (data) => {
        setImages5(data);
    };
    const handleSelectedImages6 = (images) => {
        setImages6(images);
    };
    const handleSelectedRemoveImg6 = (data) => {
        setImages6(data);
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
            const formatedBodyToServer = {
                carpark_description_en: txtEnDescValue,
                carpark_description_th: txtThDescValue,
                lpr_description_en: txtEnHelpDescValue,
                lpr_description_th: txtThHelpDescValue,
                lady_parking_description_en: txtEnBuildingDescValue,
                lady_parking_description_th: txtThBuildingDescValue,
                callpoint_description_en: txtEnMailroomDescValue,
                callpoint_description_th: txtThMailroomDescValue,
                shuttle_description_en: txtEnShuttleDescValue,
                shuttle_description_th: txtThShuttleDescValue,
                driver_description_en: txtEnDriverDescValue,
                driver_description_th: txtThDriverDescValue,
                facial_recog_description_en: txtEnfacialDescValue,
                facial_recog_description_th: txtThfacialDescValue,
                lpr_image: images1 ?? null,
                lady_parking_image: images2 ?? null,
                callpoint_description_image: images3 ?? null,
                shuttle_image: images4 ?? null,
                driver_image: images5 ?? null,
                facial_recog_image: images6 ?? null,
            }
            if (
                !formatedBodyToServer.carpark_description_en ||
                !formatedBodyToServer.carpark_description_th ||
                !formatedBodyToServer.lpr_description_en ||
                !formatedBodyToServer.lpr_description_th ||
                !formatedBodyToServer.lady_parking_description_en ||
                !formatedBodyToServer.lady_parking_description_th ||
                !formatedBodyToServer.callpoint_description_en ||
                !formatedBodyToServer.callpoint_description_th ||
                !formatedBodyToServer.shuttle_description_en ||
                !formatedBodyToServer.shuttle_description_th ||
                !formatedBodyToServer.driver_description_en ||
                !formatedBodyToServer.driver_description_th ||
                !formatedBodyToServer.facial_recog_description_en ||
                !formatedBodyToServer.facial_recog_description_th ||
                !formatedBodyToServer.lpr_image.length > 0 ||
                !formatedBodyToServer.lady_parking_image.length > 0 ||
                !formatedBodyToServer.callpoint_description_image.length > 0 ||
                !formatedBodyToServer.shuttle_image.length > 0 ||
                !formatedBodyToServer.driver_image.length > 0 ||
                !formatedBodyToServer.facial_recog_image.length > 0
            ) {
                await alertValidate();
            } else {
                const result = await alertConfirmSave();
                    if (result.isConfirmed) {
                      (async () => {
                        await setLoading(true);
                        const response = await createAndUpdateCarpark(formatedBodyToServer);
                        setLoading(false)
                          if (response.status == "success") {
                            const result = await alertSaved();
                              if (result.isConfirmed) {
                                window.location.reload();
                              }
                          }
                      })();
                    }
            }
        
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
                navigateToBack("/infoCarpark");
            }
            else { }
    };

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const result = await getDataCarpark()

            let dataPreview = result.data;
            setEditId(dataPreview._id)
            setTxtEnDescValue(dataPreview.carpark_description_en)
            setTxtThDescValue(dataPreview.carpark_description_th)
            setTxtEnHelpDescValue(dataPreview.lpr_description_en)
            setTxtThHelpDescValue(dataPreview.lpr_description_th)
            setTxtEnBuildingDescValue(dataPreview.lady_parking_description_en)
            setTxtThBuildingDescValue(dataPreview.lady_parking_description_th)
            setTxtEnMailroomDescValue(dataPreview.callpoint_description_en)
            setTxtThMailroomDescValue(dataPreview.callpoint_description_th)
            setTxtEnShuttleDescValue(dataPreview.shuttle_description_en)
            setTxtThShuttleDescValue(dataPreview.shuttle_description_th)
            setTxtEnDriverDescValue(dataPreview.driver_description_en)
            setTxtThDriverDescValue(dataPreview.driver_description_th)
            setTxtEnfacialDescValue(dataPreview.facial_recog_description_en)
            setTxtThfacialDescValue(dataPreview.facial_recog_description_th)

            const imgsLpr = dataPreview.lpr_image;
            if (imgsLpr && Array.isArray(imgsLpr)) {
                const images = await Promise.all(imgsLpr.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
            const imgsLady = dataPreview.lady_parking_image;
            if (imgsLady && Array.isArray(imgsLady)) {
                const images = await Promise.all(imgsLady.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi2(images);
            }
            const imgsCallpoint = dataPreview.callpoint_description_image;
            if (imgsCallpoint && Array.isArray(imgsCallpoint)) {
                const images = await Promise.all(imgsCallpoint.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi3(images);
            }
            const imgsShuttle = dataPreview.shuttle_image;
            if (imgsShuttle && Array.isArray(imgsShuttle)) {
                const images = await Promise.all(imgsShuttle.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi4(images);
            }
            const imgsDriver = dataPreview.driver_image;
            if (imgsDriver && Array.isArray(imgsDriver)) {
                const images = await Promise.all(imgsDriver.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi5(images);
            }
            const imgsFacial = dataPreview.facial_recog_image;
            if (imgsFacial && Array.isArray(imgsFacial)) {
                const images = await Promise.all(imgsFacial.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi6(images);
            }
        } catch (error) {
            console.log('found error', error)
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])

  return (
    <>
        <style>
            {`
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"OUR SERVICE & PRIVILEGE"} />
        <Menu
            parentmenu={"infoOurService"}
            activemenu={"infoCarpark"}
        />
        <div className="content-wrapper">
        <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-service.png" className="ic-user01 me-2" alt="" />
                                OUR SERVICE & PRIVILEGE<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> CARPARK & SECURITY SERVICE
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                    Carpark & Security Service
                                    </font>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnDescValue}
                                        onChange={(newData) => {
                                            setTxtEnDescValue(newData);
                                        }}
                                        placeholder="Description"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThDescValue}
                                        onChange={(newData) => {
                                            setTxtThDescValue(newData);
                                        }}
                                        placeholder="คำอธิบาย"
                                    />
                                </Col>
                            </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                LPR Smart Car Park
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnHelpDescValue}
                                    onChange={(newData) => {
                                        setTxtEnHelpDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThHelpDescValue}
                                    onChange={(newData) => {
                                        setTxtThHelpDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Lady Parking
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnBuildingDescValue}
                                    onChange={(newData) => {
                                        setTxtEnBuildingDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThBuildingDescValue}
                                    onChange={(newData) => {
                                        setTxtThBuildingDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages2}
                                    images={imagesFromApi2}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg2}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Call Point Service
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnMailroomDescValue}
                                    onChange={(newData) => {
                                        setTxtEnMailroomDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThMailroomDescValue}
                                    onChange={(newData) => {
                                        setTxtThMailroomDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages3}
                                    images={imagesFromApi3}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg3}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Golf Shuttle Service
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnShuttleDescValue}
                                    onChange={(newData) => {
                                        setTxtEnShuttleDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThShuttleDescValue}
                                    onChange={(newData) => {
                                        setTxtThShuttleDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages4}
                                    images={imagesFromApi4}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg4}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Driver Room
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDriverDescValue}
                                    onChange={(newData) => {
                                        setTxtEnDriverDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDriverDescValue}
                                    onChange={(newData) => {
                                        setTxtThDriverDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages5}
                                    images={imagesFromApi5}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg5}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Facial Recognition Access
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnfacialDescValue}
                                    onChange={(newData) => {
                                        setTxtEnfacialDescValue(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThfacialDescValue}
                                    onChange={(newData) => {
                                        setTxtThfacialDescValue(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages6}
                                    images={imagesFromApi6}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg6}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default Carpark